module.exports = __webpack_public_path__ + "img/open2-old.172428b2.png";